export default {
  title: {
    id: 'insurance_subscribed_title',
    defaultMessage: 'You’re already covered',
  },
  subtitle: {
    id: 'insurance_subscribed_subtitle',
    defaultMessage:
      'It seems you already bought a protection plan for your device.',
  },
  cta: {
    id: 'insurance_subscribed_cta',
    defaultMessage: 'See my protection plans',
  },
  questions: {
    id: 'insurance_subscribed_questions',
    defaultMessage: 'Got questions on protection plans?',
  },
}
